import { render, staticRenderFns } from "./page-not-found.vue?vue&type=template&id=24b9dd72"
var script = {}
import style0 from "./page-not-found.vue?vue&type=style&index=0&id=24b9dd72&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports